import { gql } from "@apollo/client";

export const getCreatorVerificationStatus = gql`
    query creatorVerificationStatus {
        user {
            creatorVerificationStatus {
                hasVerifiedPhone
            }
        }
    }
`;
